<template>
  <!-- component -->
  <div class="font-sans">
    <div class="backdrop bg-opacity-10">
      <div
        class="
          relative
          min-h-screen
          flex flex-col
          sm:justify-center
          items-center
        "
      >
        <div class="relative sm:max-w-sm w-full">
          <div
            class="
              card
              bg-blue-400
              shadow-lg
              w-full
              h-full
              rounded-3xl
              absolute
              transform
              -rotate-6
            "
          ></div>
          <div
            class="
              card
              bg-green-400
              shadow-lg
              w-full
              h-full
              rounded-3xl
              absolute
              transform
              rotate-6
            "
          ></div>
          <div
            class="relative w-full rounded-3xl px-6 py-4 bg-gray-100 shadow-md"
          >
            <div class="text-h6 text-overline">{{t('login.register')}}</div>
            <div class="q-gutter-sm">
              <q-input v-model="nameToken" type="text">{{t('login.name')}}</q-input>
              <q-input v-model="emailToken" type="email">{{t('login.email')}}</q-input>
              <q-input v-model="passwordToken" type="password"
                >{{t('login.password')}}</q-input
              >
              <q-space></q-space>
              <q-btn
                class="full-width"
                color="positive"
                @click="validateCredentials"
                >{{t('login.submit')}}</q-btn
              >
              <q-btn class="full-width" color="primary" to="/register"
                >{{t('login.already')}}</q-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
// import router from "../../router";
import { Notify } from "quasar";
import { useI18n } from "vue-i18n";

export default {
   setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return {t}},
  data() {
    return {
      stayLoggedIn: false,
      nameToken: "",
      passwordToken: "",
      emailToken: "",
      error: null,
    };
  },
  methods: {

    validateCredentials() {
      firebase
        .auth()
        .createUserWithEmailAndPassword(this.emailToken, this.passwordToken)
        .then((data) => {
          data.user
            .updateProfile({
              displayName: this.nameToken,
              profilepic: "default",
            })

            .then(() => {
              // Add user to database
              const userID = data.user.uid
              const add_user = {
                  displayName: this.nameToken,
                  admin: false,
                  profilepic: "https://i.imgur.com/92ibtIJ.png",
                  email: this.emailToken,
                  posts:0
                }
              firebase.database().ref('users/' + userID).update(add_user)
              firebase.database().ref("messages/"+ userID).update({messageList:[{ type: 'text', author: `Suport`, data: { text: `Salut! Cu ce te putem ajuta? Te rog sa ne lasi un numar de telefon sau o adresa de mail pentru a te putea contacta.` } },]})
              firebase.auth().signOut();
              Notify.create({
                icon: "mdi-checkbox-marked",
                message: this.t("login.created"),
                position: "bottom-right",
                color: "green-5",
              });

              this.$router.push("/sign-in");

              setTimeout(()=>{
                location.reload();
              },2000)
            });
        })
        .catch((err) => {
          this.error = err.message;
          alert(this.error);
        });
    },
  },
};
</script>

<style lang="scss">
/* width */
::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.font-sans {
  background-image: url("../../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.backdrop {
  backdrop-filter: blur(15px);
}
</style>